module.exports = __webpack_public_path__ + "static/media/star-as.522f9cee.png";